// import React, { useState, useRef, useEffect } from 'react';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { ChevronDown, ChevronUp, ArrowLeft, X } from 'lucide-react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { downloadMuraExcel } from '../../services/apiService';
// import { Chart as ChartJS, BarController, BarElement, CategoryScale, LinearScale, Tooltip } from 'chart.js';
// import Swal from 'sweetalert2';
// import PropTypes from 'prop-types';

// ChartJS.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);

// const productTypeData = {
//   productTypes: [
//     {
//       type: 'TV',
//       size: ['All', '32', '40', '43', '50', '55', '58', '65', '75', '85', '86', '98', '100'],
//       odm: ['All', 'TPV ODM(XM)', 'Skyworth', 'KTC', 'CHH', 'MSF', 'HKC'],
//       brand: ['All', 'PHILIPS', 'AOC', 'SAMSUNG', 'Panasonic', 'VIZIO', 'BBY', 'Element', 'XIAOMI', 'Skyworth', 'Hisense', 'Changhong', 'Huawei', 'KTC', 'HKC', 'NDS'],
  
//     },
//     {
//       type: 'MNT',
//       size: ['All', '16', '22', '24', '25', '27', '30', '32', '34', '45', '49'],
//       odm: ['All', 'TPV ODM(FQ)', 'LNT', 'HF', 'TN', 'CTX', 'DW', 'KTC'],
//       brand: ['All', 'PHILIPS', 'AOC', 'HP', 'Dell', 'ASUS', 'Acer', 'BenQ', 'MSI', 'NDS', 'Huawei', 'KTC'],
    
//     },
//     {
//       type: 'PD',
//       size: ['All', '32', '40', '43', '50', '55', '58', '65', '75', '85', '86', '98', '100'],
//       odm: ['All', 'TPV ODM(XM)', 'TPV ODM(FQ)'],
//       brand: ['All', 'PHILIPS', 'AOC'],
      
//     },
//   ],
// };

// const productTypeOptions = [
//   { value: 'All', label: 'All' },
//   { value: 'TV', label: 'TV' },
//   { value: 'MNT', label: 'MNT' },
//   { value: 'PD', label: 'PD' },
// ];

// const ProductTypeDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, productTypeRef }) => (
//   <div className="mb-4 relative" ref={productTypeRef}>
//     <div
//       className="relative cursor-pointer"
//       onClick={() => setOpenDropdown(openDropdown === 'productType' ? null : 'productType')}
//     >
//       <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 sm:px-4 sm:py-3 pr-2 text-white text-xs sm:text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between">
//         <span>
//           {filters.productType === '' ? 'Product Type' : filters.productType === 'All' ? 'All' : filters.productType}
//         </span>
//         <div className="flex flex-col items-center">
//           <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//           <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//         </div>
//       </div>
//     </div>
//     {openDropdown === 'productType' && (
//       <div className="absolute top-full left-0 mt-1 bg-slate-800 rounded-lg w-full border border-blue-500 z-50" style={{ minWidth: '150px' }}>
//         <div className="relative flex items-center px-2 py-1 sm:px-3 sm:py-2 border-b border-slate-700">
//           <X
//             onClick={() => setOpenDropdown(null)}
//             className="absolute left-2 sm:left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
//           />
//           <span className="mx-auto text-white text-xs sm:text-sm font-medium">Product Type</span>
//         </div>
//         <div className="p-0">
//           {productTypeOptions.map((option) => (
//             <div
//               key={option.value}
//               className="flex items-center justify-between px-3 py-2 sm:px-4 sm:py-3 hover:bg-slate-600 cursor-pointer border-b border-slate-700 last:border-b-0"
//               onClick={() => handleFilterChange('productType', option.value)}
//             >
//               <span className="text-white text-xs sm:text-sm">{option.label}</span>
//               <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full border-2 border-slate-500 flex items-center justify-center">
//                 {filters.productType === option.value && <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-white"></div>}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     )}
//   </div>
// );


// const SizeDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, sizeRef, sizeOptions }) => {
//   const sizePairs = [];
//   for (let i = 0; i < sizeOptions.length; i += 2) {
//     sizePairs.push([sizeOptions[i], sizeOptions[i + 1]].filter(Boolean));
//   }

//   return (
//     <div className="mb-4 relative" ref={sizeRef}>
//       <div
//         className="relative cursor-pointer"
//         onClick={() => setOpenDropdown(openDropdown === 'size' ? null : 'size')}
//       >
//         <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 sm:px-4 sm:py-3 pr-2 text-white text-xs sm:text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between">
//           <span>{filters.size === '' ? 'Size' : filters.size}</span>
//           <div className="flex flex-col items-center">
//             <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//             <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//           </div>
//         </div>
//       </div>
//       {openDropdown === 'size' && sizeOptions.length > 0 && (
//         <div
//           className="absolute top-full left-0 mt-1 bg-slate-800 rounded-lg w-full border-2 border-blue-500 z-50"
//           style={{ minWidth: '150px' }}
//         >
//           <div className="relative flex items-center px-2 py-1 sm:px-3 sm:py-2 border-b border-slate-700">
//             <X
//               onClick={() => setOpenDropdown(null)}
//               className="absolute left-2 sm:left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
//             />
//             <span className="mx-auto text-white text-xs sm:text-sm font-medium">Size</span>
//           </div>
//           <div className="p-2 sm:p-4 max-h-80 overflow-y-auto">
//             {sizePairs.map((pair, index) => (
//               <div key={index} className="grid grid-cols-2 gap-2 sm:gap-3 mb-2 sm:mb-3">
//                 {pair.map((size) => (
//                   <div
//                     key={size}
//                     className="flex items-center justify-between px-3 py-2 sm:px-4 sm:py-3 hover:bg-slate-600 cursor-pointer border-b border-slate-700"
//                     onClick={() => handleFilterChange('size', size)}
//                   >
//                     <span className="text-white text-xs sm:text-sm">{size}</span>
//                     <div
//                       className={`w-4 h-4 sm:w-5 sm:h-5 border-2 flex items-center justify-center ${
//                         filters.size === size ? 'border-blue-500 bg-blue-500' : 'border-slate-500'
//                       }`}
//                       style={{ borderRadius: '2px' }}
//                     >
//                       {filters.size === size && (
//                         <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white" style={{ borderRadius: '1px' }}></div>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };


// const OdmDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, odmRef, odmOptions }) => (
//   <div className="mb-4 relative" ref={odmRef}>
//     <div
//       className="relative cursor-pointer"
//       onClick={() => setOpenDropdown(openDropdown === 'odm' ? null : 'odm')}
//     >
//       <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 sm:px-4 sm:py-3 pr-2 text-white text-xs sm:text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between">
//         <span>{filters.odm === 'All' ? 'All' : filters.odm}</span>
//         <div className="flex flex-col items-center">
//           <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//           <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//         </div>
//       </div>
//     </div>
//     {openDropdown === 'odm' && odmOptions.length > 0 && (
//       <div
//         className="absolute top-full left-0 mt-1 bg-slate-800 rounded-lg w-full border border-blue-500 z-50"
//         style={{ minWidth: '150px' }}
//       >
//         <div className="relative flex items-center px-2 py-1 sm:px-3 sm:py-2 border-b border-slate-700">
//           <X
//             onClick={() => setOpenDropdown(null)}
//             className="absolute left-2 sm:left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
//           />
//           <span className="mx-auto text-white text-xs sm:text-sm font-medium">ODM</span>
//         </div>
//         <div className="p-0">
//           {odmOptions.map((option) => (
//             <div
//               key={option}
//               className="flex items-center justify-between px-3 py-2 sm:px-4 sm:py-3 hover:bg-slate-600 cursor-pointer border-b border-slate-700 last:border-b-0"
//               onClick={() => handleFilterChange('odm', option)}
//             >
//               <span className="text-white text-xs sm:text-sm">{option}</span>
//               <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full border-2 border-slate-500 flex items-center justify-center">
//                 {filters.odm === option && <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-white"></div>}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     )}
//   </div>
// );

// const BrandDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, brandRef, brandOptions }) => (
//   <div className="mb-4 relative" ref={brandRef}>
//     <div
//       className="relative cursor-pointer"
//       onClick={() => setOpenDropdown(openDropdown === 'brand' ? null : 'brand')}
//     >
//       <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 sm:px-4 sm:py-3 pr-2 text-white text-xs sm:text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between">
//         <span>{filters.brand === '' ? 'Brand' : filters.brand}</span>
//         <div className="flex flex-col items-center">
//           <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//           <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4 pointer-events-none" />
//         </div>
//       </div>
//     </div>
//     {openDropdown === 'brand' && brandOptions.length > 0 && (
//       <div
//         className="absolute top-full left-0 mt-1 bg-slate-800 rounded-lg w-full border border-blue-500 z-50"
//         style={{ minWidth: '150px' }}
//       >
//         <div className="relative flex items-center px-2 py-1 sm:px-3 sm:py-2 border-b border-slate-700">
//           <X
//             onClick={() => setOpenDropdown(null)}
//             className="absolute left-2 sm:left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
//           />
//           <span className="mx-auto text-white text-xs sm:text-sm font-medium">Brand</span>
//         </div>
//         <div className="p-0">
//           {brandOptions.map((option) => (
//             <div
//               key={option}
//               className="flex items-center justify-between px-3 py-2 sm:px-4 sm:py-3 hover:bg-slate-600 cursor-pointer border-b border-slate-700 last:border-b-0"
//               onClick={() => handleFilterChange('brand', option)}
//             >
//               <span className="text-white text-xs sm:text-sm">{option}</span>
//               <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full border-2 border-slate-500 flex items-center justify-center">
//                 {filters.brand === option && <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-white"></div>}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     )}
//   </div>
// );


// const FilterDropdown = ({ label, value, onChange, name }) => (
//   <div className="mb-4 relative">
//     <div className="relative">
//       <select
//         value={value}
//         onChange={(e) => onChange(name, e.target.value)}
//         className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-3 sm:px-4 sm:py-4 pr-8 text-white text-xs sm:text-sm appearance-none focus:outline-none focus:border-blue-500"
//       >
//         <option value="">{label}</option>
//         <option value="last_week">Last Week</option>
//         <option value="last_month">Last Month</option>
//         <option value="custom">Custom</option>
//       </select>
//       <div className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 flex flex-col items-center pointer-events-none">
//         <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
//         <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
//       </div>
//     </div>
//   </div>
// );


// const DefectChart = ({
//   chartData,
//   currentFilters,
//   currentChartData,
//   sizeOptions,
//   odmOptions,
//   brandOptions,
//   setSelectedDefectType = () => console.warn('setSelectedDefectType not provided'),
// }) => {
//   const chartRef = useRef(null);
//   const chartInstanceRef = useRef(null);
//   const navigate = useNavigate();

//   const handleLabelClick = (defectType) => {
//     if (typeof setSelectedDefectType === 'function') {
//       setSelectedDefectType(defectType);
//       localStorage.setItem('dashboardFilters', JSON.stringify(currentFilters));
//       localStorage.setItem('dashboardChartData', JSON.stringify(currentChartData));
//       navigate('/photo-gallery', {
//         state: {
//           defectType: defectType,
//           filters: currentFilters,
//           chartData: currentChartData,
//           sizeOptions: sizeOptions,
//           odmOptions: odmOptions,
//           brandOptions: brandOptions,
//         },
//       });
//     } else {
//       console.error('setSelectedDefectType is not a function');
//     }
//   };

//   useEffect(() => {
//     const ctx = chartRef.current?.getContext('2d');
//     if (!ctx) return;

//     if (chartInstanceRef.current) {
//       chartInstanceRef.current.destroy();
//       chartInstanceRef.current = null;
//     }
//     const filteredChartData = chartData.filter(item => item.label.toLowerCase() !== 'other');

//     const tempCanvas = document.createElement('canvas');
//     const tempCtx = tempCanvas.getContext('2d');
//     tempCtx.font = '11px sans-serif';

//     const labelWidths = filteredChartData.map((item) => Math.max(35, tempCtx.measureText(item.label).width + 15));

//     chartInstanceRef.current = new ChartJS(ctx, {
//       type: 'bar',
//       data: {
//         labels: filteredChartData.map((item) => item.label),
//         datasets: [
//           {
//             label: 'Defect Quantity',
//             data: filteredChartData.map((item) => item.quantity),
//             backgroundColor: 'rgba(71, 85, 105, 0.8)',
//             hoverBackgroundColor: 'rgba(100, 116, 139, 0.8)',
//             borderRadius: 2,
//           },
//         ],
//       },
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         scales: {
//           y: {
//             beginAtZero: true,
//             title: { display: false },
//             ticks: { display: false },
//           },
//           x: {
//             ticks: {
//               color: '#e2e8f0',
//               maxRotation: 0,
//               minRotation: 0,
//               autoSkip: false,
//               padding: 5,
//               font: { size: 10 },
//               callback: function (value) {
//                 const label = this.getLabelForValue(value);
//                 if (label.toLowerCase().includes("pressing light leakage")) {
//                   return label + "               ";
//                 }
//                 return label;
//               },
//             },
//             grid: { display: false },
//             offset: true,
//             afterFit: function (axis) {
//               axis.paddingLeft = 5;
//               axis.paddingRight = 5;
//             },
//             categoryPercentage: 0.9,
//             barPercentage: 0.9,
//           },
//         },
//         plugins: {
//           legend: { display: false },
//           tooltip: {
//             backgroundColor: '#1e293b',
//             titleColor: '#e2e8f0',
//             bodyColor: '#e2e8f0',
//           },
//         },
//         layout: {
//           padding: { left: 26, top: 10, },
//         },
//         onClick: (event, elements) => {
//           if (elements.length > 0) {
//             const index = elements[0].index;
//             const item = filteredChartData[index];
//             if (item && item.label) {
//               handleLabelClick(item.label);
//             } else {
//               console.warn('No label found for clicked element');
//             }
//           }
//         },
//       },
//       plugins: [
//         {
//           id: 'barEndLine',
//           afterDatasetsDraw(chart) {
//             const { ctx } = chart;
//             const meta = chart.getDatasetMeta(0);

//             ctx.save();
//             ctx.strokeStyle = 'white';
//             ctx.lineWidth = 1;

//             meta.data.forEach((bar) => {
//               const { x, y, width } = bar;
//               const left = x - width / 2;
//               const right = x + width / 2;

//               ctx.beginPath();
//               ctx.moveTo(left, y);
//               ctx.lineTo(right, y);
//               ctx.stroke();
//             });

//             ctx.restore();
//           },
//         },
//       ],
//     });

//     const totalWidth = labelWidths.reduce((sum, width) => sum + width, 0);
//     const container = chartRef.current.parentElement;
//     container.style.width = `${Math.max(650, totalWidth + 20)}px`;

//     return () => {
//       if (chartInstanceRef.current) {
//         chartInstanceRef.current.destroy();
//         chartInstanceRef.current = null;
//       }
//     };
//   }, [chartData, currentFilters, currentChartData, sizeOptions, odmOptions, brandOptions, setSelectedDefectType, navigate]);

//   return (
//     <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
//       <div style={{ height: '210px', padding: '0 4px', position: 'relative' }}>
//         <canvas ref={chartRef} style={{ width: '100%', height: '100%', display: 'block' }} />
//       </div>
//     </div>
//   );

// };

// DefectChart.propTypes = {
//   chartData: PropTypes.array.isRequired,
//   currentFilters: PropTypes.object.isRequired,
//   currentChartData: PropTypes.array.isRequired,
//   sizeOptions: PropTypes.array.isRequired,
//   odmOptions: PropTypes.array.isRequired,
//   brandOptions: PropTypes.array.isRequired,
//   setSelectedDefectType: PropTypes.func,
// };

// const StatisticsAndAnalysis = () => {
//   const [filters, setFilters] = useState({
//     productType: 'All',
//     size: 'All',
//     odm: 'All',
//     brand: 'All',
//     datePeriod: 'All',
//     customDateFrom: '',
//     customDateTo: '',
//   });
//   const [selectedDefectType, setSelectedDefectType] = useState('');
//   const [currentChartData, setCurrentChartData] = useState([]);
//   const [chartDataState, setChartDataState] = useState([]);
//   const [allData, setAllData] = useState([]);
//   const [sizeOptions, setSizeOptions] = useState(['All']);
//   const [odmOptions, setOdmOptions] = useState(['All']);
//   const [brandOptions, setBrandOptions] = useState(['All']);
//   const [analysisData, setAnalysisData] = useState([]);
//   const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
//   const productTypeRef = useRef(null);
//   const sizeRef = useRef(null);
//   const odmRef = useRef(null);
//   const brandRef = useRef(null);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [filtersApplied, setFiltersApplied] = useState(false);

//   const isFormValid =
//     filters.productType !== '' &&
//     filters.productType !== 'Product Type' &&
//     filters.size !== '' &&
//     filters.size !== 'Size' &&
//     filters.odm !== '' &&
//     filters.odm !== 'ODM' &&
//     filters.brand !== '' &&
//     filters.brand !== 'Brand' &&
//     filters.datePeriod !== '' &&
//     filters.datePeriod !== 'Date Period' &&
//     (filters.datePeriod !== 'custom' ||
//       (filters.customDateFrom !== '' && filters.customDateTo !== ''));

//   const formatMuraType = (muraType) => {
//     if (!muraType) return 'Unknown';
//     return muraType
//       .split('_')
//       .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(' ');
//   };

//   const processChartData = (data) => {
//     const dataArray = Array.isArray(data) ? data : data?.data || [];
//     if (!Array.isArray(dataArray)) {
//       console.error('processChartData: Expected an array but received:', data);
//       return [];
//     }

//     const muraTypeCounts = {};
    
//     dataArray.forEach(item => {
//       let defects = [];
      
//       if (item.MuraRecording && item.MuraRecording.muraLabeling && item.MuraRecording.muraLabeling.defects) {
//         defects = item.MuraRecording.muraLabeling.defects;
//       } else if (item.muraLabeling && item.muraLabeling.defects) {
//         defects = item.muraLabeling.defects;
//       } else if (item.defects) {
//         defects = item.defects;
//       }
      
//       if (!Array.isArray(defects)) {
//         console.warn('Defects is not an array:', defects);
//         defects = [];
//       }

//       defects.forEach(defect => {
//         const muraType = defect?.muraType || defect?.type || 'Unknown';
//         muraTypeCounts[muraType] = (muraTypeCounts[muraType] || 0) + 1;
//       });
//     });

//     const formattedData = Object.entries(muraTypeCounts)
//       .map(([muraType, quantity], index) => ({
//         id: index + 1,
//         label: formatMuraType(muraType),
//         quantity,
//       }))
//       .filter(item => item.label !== "Other")
//       .sort((a, b) => b.quantity - a.quantity);
//     return formattedData;
//   };

//   const handleLabelClick = (defectType) => {
//     setSelectedDefectType(defectType);
//     navigate('/photo-gallery', {
//       state: {
//         defectType,
//         filters: { ...filters },
//         analysis: currentChartData,
//         sizeOptions,
//         odmOptions,
//         brandOptions,
//       },
//     });
//   };

//   useEffect(() => {
//     const { state } = location;
//     let initialFilters = {
//       productType: 'All',
//       size: 'All',
//       odm: 'All',
//       brand: 'All',
//       datePeriod: 'All',
//       customDateFrom: '',
//       customDateTo: '',
//     };
//     let initialSizeOptions = ['All'];
//     let initialOdmOptions = ['All'];
//     let initialBrandOptions = ['All'];

//     const normalizeData = (data) => {
//       if (Array.isArray(data)) return data;
//       if (data && Array.isArray(data.data)) return data.data;
//       if (data && Array.isArray(data.results)) return data.results;
//       return [];
//     };

//     if (state && state.analysis) {
//       const analysisArray = normalizeData(state.analysis);
//       if (analysisArray.length > 0) {
//         setAnalysisData(analysisArray);
//         setAllData(analysisArray);
//         const formattedData = processChartData(analysisArray);
//         setCurrentChartData(analysisArray);
//         setChartDataState(formattedData);
//         setHasAppliedFilters(false);
//       } else {
//         console.error('Analysis data is empty or invalid:', state.analysis);
//         Swal.fire({
//           icon: 'error',
//           title: 'Invalid Data',
//           text: 'The analysis data received is empty or not in the expected format.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff4444',
//         });
//       }
//       if (state && state.filters) {
//         initialFilters = { ...state.filters };
//       }
//     } else {
//       const storedFilters = localStorage.getItem('dashboardFilters');
//       const storedChartData = localStorage.getItem('dashboardChartData');
//       if (storedFilters) {
//         try {
//           initialFilters = JSON.parse(storedFilters);
//         } catch (error) {
//           console.error('Error parsing stored filters:', error);
//         }
//       }
//       if (storedChartData) {
//         try {
//           const parsedData = JSON.parse(storedChartData);
//           const analysisArray = normalizeData(parsedData);
//           if (analysisArray.length > 0) {
//             setAnalysisData(analysisArray);
//             setAllData(analysisArray);
//             const formattedData = processChartData(analysisArray);
//             setCurrentChartData(analysisArray);
//             setChartDataState(formattedData);
//             setHasAppliedFilters(false);
//           } else {
//             console.error('Stored chart data is empty or invalid:', parsedData);
//           }
//         } catch (error) {
//           console.error('Error parsing stored chart data:', error);
//         }
//       }
//     }

//     const selectedProduct = productTypeData.productTypes.find((pt) => pt.type === initialFilters.productType) || {
//       size: ['All'],
//       odm: ['All'],
//       brand: ['All'],
//     };
//     initialSizeOptions = state?.sizeOptions || [...selectedProduct.size];
//     initialOdmOptions = state?.odmOptions || [...selectedProduct.odm];
//     initialBrandOptions = state?.brandOptions || [...selectedProduct.brand];

//     setFilters(initialFilters);
//     setSizeOptions(initialSizeOptions);
//     setOdmOptions(initialOdmOptions);
//     setBrandOptions(initialBrandOptions);
//   }, [location]);

//   useEffect(() => {
//     if (filters.productType && filters.productType !== 'Product Type') {
//       const selectedProduct = productTypeData.productTypes.find((pt) => pt.type === filters.productType) || {
//         size: ['All'],
//         odm: ['All'],
//         brand: ['All'],
//       };
//       setSizeOptions([...selectedProduct.size]);
//       setOdmOptions([...selectedProduct.odm]);
//       setBrandOptions([...selectedProduct.brand]);
//     } else {
//       setSizeOptions(['All']);
//       setOdmOptions(['All']);
//       setBrandOptions(['All']);
//     }
//   }, [filters.productType]);

//   const handleBackClick = () => {
//     navigate('/dashboard');
//   };

//   const handleFilterChange = (name, value) => {
//     setFilters((prev) => ({ ...prev, [name]: value }));
//     setOpenDropdown(null);
//     setFiltersApplied(false); 
//     localStorage.setItem('dashboardFilters', JSON.stringify({ ...filters, [name]: value }));
//   };

//   const updateChart = () => {
//     if (!Array.isArray(allData) || allData.length === 0) {
//       console.error('All data is not an array or is empty:', allData);
//       Swal.fire({
//         icon: 'error',
//         title: 'No Data Available',
//         text: 'No valid data available to filter.',
//         confirmButtonText: 'OK',
//         confirmButtonColor: '#ff4444',
//       });
//       return;
//     }

//     try {
//       let filteredData = [...allData];

//       if (filters.productType && filters.productType !== 'Product Type' && filters.productType !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemProductType = item.productInfo?.productType || '';
//           return String(itemProductType).toLowerCase() === String(filters.productType).toLowerCase();
//         });
//       } else {
//       }

//       if (filters.size && filters.size !== 'Size' && filters.size !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemInchSize = item.productInfo?.inchSize || '';
//           return String(itemInchSize) === String(filters.size);
//         });
//       } else {
//       }

//       if (filters.odm && filters.odm !== 'ODM' && filters.odm !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemOdm = item.productInfo?.odm || '';
//           return String(itemOdm) === String(filters.odm);
//         });
//       } else {
//       }

//       if (filters.brand && filters.brand !== 'Brand' && filters.brand !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemBrand = item.productInfo?.brand || '';
//           return String(itemBrand) === String(filters.brand);
//         });

//       } else {
//       }

//       if (filters.datePeriod && filters.datePeriod !== 'Date Period' && filters.datePeriod !== 'All') {
//         let fromDate, toDate;

//         if (filters.datePeriod === 'custom' && filters.customDateFrom && filters.customDateTo) {
//           fromDate = new Date(filters.customDateFrom);
//           toDate = new Date(filters.customDateTo);
//           toDate.setHours(23, 59, 59, 999);
//         } else if (filters.datePeriod === 'last_week') {
//           toDate = new Date();
//           fromDate = new Date();
//           fromDate.setDate(toDate.getDate() - 7);
//           toDate.setHours(23, 59, 59, 999);
//         } else if (filters.datePeriod === 'last_month') {
//           toDate = new Date();
//           fromDate = new Date();
//           fromDate.setMonth(toDate.getMonth() - 1);
//           toDate.setHours(23, 59, 59, 999);
//         }

//         if (fromDate && toDate && !isNaN(fromDate) && !isNaN(toDate)) {
//           filteredData = filteredData.filter(item => {
//             const itemDateStr = item.createdAt || '';
//             if (!itemDateStr) {
//               return false;
//             }
//             const itemDate = new Date(itemDateStr);
//             const isValidDate = !isNaN(itemDate);
//             return isValidDate && itemDate >= fromDate && itemDate <= toDate;
//           });
//         } else {
//         }
//       } else {
//       }

//       const formattedData = processChartData(filteredData);
//       setCurrentChartData(filteredData);
//       setChartDataState(formattedData);
//       setHasAppliedFilters(true);
//       setFiltersApplied(true);
//       localStorage.setItem('dashboardChartData', JSON.stringify(filteredData));
//       localStorage.setItem('dashboardFilters', JSON.stringify(filters));
//     } catch (error) {
//       console.error('Error filtering chart data:', error);
//       Swal.fire({
//         icon: 'error',
//         title: 'Failed to Filter Data',
//         text: error.message || 'Something went wrong filtering the data.',
//         confirmButtonText: 'OK',
//         confirmButtonColor: '#ff4444',
//       });
//     }
//   };

//   const exportData = async () => {
//     try {
//       if (!Array.isArray(allData) || allData.length === 0) {
//         console.error('All data is not an array or is empty:', allData);
//         Swal.fire({
//           icon: 'error',
//           title: 'No Data Available',
//           text: 'No valid data available to export.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff4444',
//         });
//         return;
//       }
//       let filteredData = [...allData];
  
//       if (filters.productType && filters.productType !== 'Product Type' && filters.productType !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemProductType = item.productInfo?.productType || '';
//           return String(itemProductType).toLowerCase() === String(filters.productType).toLowerCase();
//         });
//       }

//       if (filters.size && filters.size !== 'Size' && filters.size !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemInchSize = item.productInfo?.inchSize || '';
//           return String(itemInchSize) === String(filters.size);
//         });
//       }

//       if (filters.odm && filters.odm !== 'ODM' && filters.odm !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemOdm = item.productInfo?.odm || '';
//           return String(itemOdm) === String(filters.odm);
//         });
//       }
//       if (filters.brand && filters.brand !== 'Brand' && filters.brand !== 'All') {
//         filteredData = filteredData.filter(item => {
//           const itemBrand = item.productInfo?.brand || '';
//           return String(itemBrand) === String(filters.brand);
//         });
//       }
//       if (filters.datePeriod && filters.datePeriod !== 'Date Period' && filters.datePeriod !== 'All') {
//         let fromDate, toDate;
  
//         if (filters.datePeriod === 'custom' && filters.customDateFrom && filters.customDateTo) {
//           fromDate = new Date(filters.customDateFrom);
//           toDate = new Date(filters.customDateTo);
//           toDate.setHours(23, 59, 59, 999);
//         } else if (filters.datePeriod === 'last_week') {
//           toDate = new Date();
//           fromDate = new Date();
//           fromDate.setDate(toDate.getDate() - 7);
//           toDate.setHours(23, 59, 59, 999);
//         } else if (filters.datePeriod === 'last_month') {
//           toDate = new Date();
//           fromDate = new Date();
//           fromDate.setMonth(toDate.getMonth() - 1);
//           toDate.setHours(23, 59, 59, 999);
//         }
  
//         if (fromDate && toDate && !isNaN(fromDate) && !isNaN(toDate)) {
//           filteredData = filteredData.filter(item => {
//             const itemDateStr = item.createdAt || '';
//             if (!itemDateStr) {
//               return false;
//             }
//             const itemDate = new Date(itemDateStr);
//             const isValidDate = !isNaN(itemDate);
//             return isValidDate && itemDate >= fromDate && itemDate <= toDate;
//           });
//         }
//       }  
//       if (filteredData.length === 0) {
//         Swal.fire({
//           icon: 'warning',
//           title: 'No Data to Export',
//           text: 'No data matches the current filters.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff9800',
//         });
//         return;
//       }
//       Swal.fire({
//         title: 'Generating Excel File...',
//         text: `Processing ${filteredData.length} records`,
//         icon: 'info',
//         allowOutsideClick: false,
//         showConfirmButton: false,
//         willOpen: () => {
//           Swal.showLoading();
//         },
//       });
//       const result = await downloadMuraExcel(filteredData);
//       if (result.success && result.downloadUrl) {
//         Swal.close();
//         Swal.fire({
//           icon: 'success',
//           title: 'Excel Generated Successfully!',
//           text: `${filteredData.length} records exported. Download will start automatically.`,
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#4CAF50',
//           timer: 3000,
//           timerProgressBar: true,
//         });
//         const downloadLink = `${process.env.REACT_APP_BACKEND_URL}/b${result.downloadUrl}`;
        
//         window.open(downloadLink, '_blank');
  
//       } else {
//         throw new Error(result.message || 'Failed to generate Excel file');
//       }
  
//     } catch (error) {
//       console.error('Export failed:', error);
    
//       Swal.close();
     
//       if (error.message.includes('Authentication error') || error.message.includes('401') || error.message.includes('token')) {
//         Swal.fire({
//           icon: 'error',
//           title: 'Authentication Failed',
//           text: 'Your session has expired. Please log in again.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff4444',
//         });
//       } else if (error.message.includes('403')) {
//         Swal.fire({
//           icon: 'error',
//           title: 'Access Denied',
//           text: 'You do not have permission to export data.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff4444',
//         });
//       } else if (error.message.includes('400') || error.message.includes('Invalid data')) {
//         Swal.fire({
//           icon: 'error',
//           title: 'Invalid Data',
//           text: 'The data format is invalid. Please try again.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff4444',
//         });
//       } else if (error.message.includes('500') || error.message.includes('Server error')) {
//         Swal.fire({
//           icon: 'error',
//           title: 'Server Error',
//           text: 'Server is temporarily unavailable. Please try again later.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff4444',
//         });
//       } else {
//         Swal.fire({
//           icon: 'error',
//           title: 'Export Failed',
//           text: error.message || 'An error occurred while exporting data.',
//           confirmButtonText: 'OK',
//           confirmButtonColor: '#ff4444',
//         });
//       }
//     }
//   };
  

  
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         productTypeRef.current &&
//         !productTypeRef.current.contains(event.target) &&
//         sizeRef.current &&
//         !sizeRef.current.contains(event.target) &&
//         odmRef.current &&
//         !odmRef.current.contains(event.target) &&
//         brandRef.current &&
//         !brandRef.current.contains(event.target)
//       ) {
//         setOpenDropdown(null);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   return (
//     <div className="min-h-screen bg-black text-white pt-1">
//       <div className="bg-black text-white px-4 sm:px-6 py-4 flex items-center border-b border-gray-600">
//         <ArrowLeft
//           className="w-5 h-5 mr-3 text-white-400 cursor-pointer hover:text-white"
//           onClick={handleBackClick}
//         />
//         <h1 className="text-base sm:text-lg font-medium ">Statistics and Analysis</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row">
//         <div className="w-full lg:w-75 bg-black p-5 border-b lg:border-b-0 border-gray-700">
//           <h2 className="text-base sm:text-xl font-medium mb-5 pt-7  sm:mb-8">Filter Dimensions</h2>
//           <ProductTypeDropdown
//             filters={filters}
//             handleFilterChange={handleFilterChange}
//             openDropdown={openDropdown}
//             setOpenDropdown={setOpenDropdown}
//             productTypeRef={productTypeRef}
//           />
//           <SizeDropdown
//             filters={filters}
//             handleFilterChange={handleFilterChange}
//             openDropdown={openDropdown}
//             setOpenDropdown={setOpenDropdown}
//             sizeRef={sizeRef}
//             sizeOptions={sizeOptions}
//           />
//           <OdmDropdown
//             filters={filters}
//             handleFilterChange={handleFilterChange}
//             openDropdown={openDropdown}
//             setOpenDropdown={setOpenDropdown}
//             odmRef={odmRef}
//             odmOptions={odmOptions}
//           />
//           <BrandDropdown
//             filters={filters}
//             handleFilterChange={handleFilterChange}
//             openDropdown={openDropdown}
//             setOpenDropdown={setOpenDropdown}
//             brandRef={brandRef}
//             brandOptions={brandOptions}
//           />
//           <FilterDropdown
//             label="Date Period"
//             value={filters.datePeriod}
//             onChange={handleFilterChange}
//             name="datePeriod"
//           />
//           <div className="mb-1">
//             <h3 className="text-xs sm:text-sm font-medium mb-2 pt-4 text-white-300">Custom Date Range</h3>
//             <div className="mb-4">
//               <DatePicker
//                 selected={filters.customDateFrom ? new Date(filters.customDateFrom) : null}
//                 onChange={(date) =>
//                   handleFilterChange(
//                     "customDateFrom",
//                     date ? date.toLocaleDateString("en-CA") : ""
//                   )
//                 }
//                 placeholderText="From"
//                 className="w-full bg-slate-800 border border-slate-600 rounded-lg px-20 py-3 text-white text-xs placeholder-slate-400 focus:outline-none focus:border-blue-500 text-left sm:px-8 sm:py-5 sm:text-sm lg:px-14 lg:py-3 lg:text-base"
//                 dateFormat="yyyy-MM-dd"
//                 maxDate={filters.customDateTo ? new Date(filters.customDateTo) : null}
//               />
//             </div>
//             <div className="mb-4 sm:mb-5">
//               <DatePicker
//                 selected={filters.customDateTo ? new Date(filters.customDateTo) : null}
//                 onChange={(date) =>
//                   handleFilterChange(
//                     "customDateTo",
//                     date ? date.toLocaleDateString("en-CA") : ""
//                   )
//                 }
//                 placeholderText="To"
//                 className="w-full bg-slate-800 border border-slate-600 rounded-lg px-20 py-3 text-white text-xs placeholder-slate-400 focus:outline-none focus:border-blue-500 text-left sm:px-8 sm:py-5 sm:text-sm lg:px-14 lg:py-3 lg:text-base"
//                 dateFormat="yyyy-MM-dd"
//                 minDate={filters.customDateFrom ? new Date(filters.customDateFrom) : null}
//               />
//             </div>
//           </div>

//            <button
//             onClick={updateChart}
//             disabled={!isFormValid}
//             className={`w-full py-2 sm:py-3 px-4 rounded-full mb-2 text-xs sm:text-sm font-medium transition-colors
//               ${isFormValid  ? "bg-blue-600 hover:bg-blue-500 text-white cursor-pointer" : "bg-slate-700 text-slate-400 cursor-not-allowed"}`}
//           >
//             {filtersApplied ? "Chart Updated" : "Update Chart"}
//           </button> 
           
//           <button
//             onClick={exportData}
//             className="w-full bg-slate-800 hover:bg-slate-700 text-white py-2 sm:py-3 px-4 rounded-full text-xs sm:text-sm font-medium transition-colors"
//           >
//             Export
//           </button>
//         </div>
//         <div className="flex-1 bg-black  ">
//           <div className="bg-black text-white px-4 lg:px-6 py-4 border-gray-600 mb-4  sm:mb-5">
//             <h1 className="text-2xl sm:text-3xl font-medium mb-2 sm:mb-3">Defect Data Overview</h1>
//             <p className="text-slate-400 text-xs sm:text-sm mb-3 mt-5 ">
//               Interactive visualization of product defect statistics
//             </p>
//           </div>

//           <div className="bg-black h-82 rounded-lg p-4 sm:p-5 mb-1 border py-3 border-gray-500">
//             <div className="mb-1">
//               <h2 className="text-base sm:text-lg font-medium mb-1">Defect Distribution by Issue Type</h2>
//               {/* <h3 className="text-lg sm:text-xl font-semibold mb-1">
//                 {filters.productType || "All"} {filters.size || ""} {filters.odm || ""} {filters.brand || ""}
//               </h3> */}
//               {/* <p className="text-slate-400 text-xs sm:text-sm">{filters.datePeriod || "Last Month"}</p> */}
//             </div>
//             <div className="relative bg-black rounded-lg ">
//               {chartDataState.length > 0 || !hasAppliedFilters ? (
//                 <DefectChart
//                   chartData={chartDataState}
//                   currentFilters={filters}
//                   currentChartData={currentChartData}
//                   sizeOptions={sizeOptions}
//                   odmOptions={odmOptions}
//                   brandOptions={brandOptions}
//                   setSelectedDefectType={setSelectedDefectType}
//                   onLabelClick={handleLabelClick}
//                 />
//               ) : (
//                 <div className="text-slate-400 text-center py-4 text-xs sm:text-sm">
//                   No defect data available for the selected filters
//                 </div>
//               )}
//             </div>
//           </div>
//           <div className="bg-black rounded-lg p-4 sm:p-1 ">
//             <h3 className="text-xl sm:text-2xl font-medium sm:mb-7">Chart Detail Info</h3>
//             <div className="overflow-hidden">
//               <div className="grid grid-cols-2 text-xs sm:text-sm">
//                 <div className="font-medium bg-gray-800 text-slate-300 py-2 px-3 sm:px-4 border-b border-slate-700">
//                   Issue Type
//                 </div>
//                 <div className="font-medium bg-gray-800 text-slate-300 py-2 px-3 sm:px-4 border-b border-slate-700">
//                   Quantity
//                 </div>
//                 {chartDataState.length > 0 || !hasAppliedFilters ? (
//                   chartDataState.map((item) => (
//                     <React.Fragment key={item.id}>
//                       <div className="py-4 px-3 sm:px-4 border-b border-slate-700 text-slate-200">
//                         {item.label}
//                       </div>
//                       <div className="py-4 px-3 sm:px-4 border-b border-slate-700 text-slate-200">
//                         {item.quantity}
//                       </div>
//                     </React.Fragment>
//                   ))
//                 ) : (
//                   <div className="col-span-2 py-2 px-3 sm:px-4 text-slate-400">
//                     No defect data available for the selected filters
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StatisticsAndAnalysis;

// ujjwal
import React, { useState, useRef, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ChevronDown, ChevronUp, ArrowLeft, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { downloadMuraExcel } from '../../services/apiService';
import { Chart as ChartJS, BarController, BarElement, CategoryScale, LinearScale, Tooltip } from 'chart.js';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';

ChartJS.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);

const productTypeData = {
  productTypes: [
    {
      type: 'TV',
      size: ['All', '32', '40', '43', '50', '55', '58', '65', '75', '85', '86', '98', '100'],
      odm: ['All', 'TPV ODM(XM)', 'Skyworth', 'KTC', 'CHH', 'MSF', 'HKC'],
      brand: ['All', 'PHILIPS', 'AOC', 'SAMSUNG', 'Panasonic', 'VIZIO', 'BBY', 'Element', 'XIAOMI', 'Skyworth', 'Hisense', 'Changhong', 'Huawei', 'KTC', 'HKC', 'NDS'],
    },
    {
      type: 'MNT',
      size: ['All', '16', '22', '24', '25', '27', '30', '32', '34', '45', '49'],
      odm: ['All', 'TPV ODM(FQ)', 'LNT', 'HF', 'TN', 'CTX', 'DW', 'KTC'],
      brand: ['All', 'PHILIPS', 'AOC', 'HP', 'Dell', 'ASUS', 'Acer', 'BenQ', 'MSI', 'NDS', 'Huawei', 'KTC'],
    },
    {
      type: 'PD',
      size: ['All', '32', '40', '43', '50', '55', '58', '65', '75', '85', '86', '98', '100'],
      odm: ['All', 'TPV ODM(XM)', 'TPV ODM(FQ)'],
      brand: ['All', 'PHILIPS', 'AOC'],
    },
  ],
};

const productTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'TV', label: 'TV' },
  { value: 'MNT', label: 'MNT' },
  { value: 'PD', label: 'PD' },
];

// Helper functions for missing data fields
const extractSizeFromProduct = (productInfo) => {
  // Try to extract from modelName (e.g., "27E4CV" -> "27")
  const modelMatch = productInfo?.modelName?.match(/(\d+)/);
  if (modelMatch) {
    return modelMatch[1];
  }
  
  // Calculate approximate size from dimensions (diagonal in inches)
  if (productInfo?.dimensions?.width?.whole && productInfo?.dimensions?.height?.whole) {
    const widthCm = productInfo.dimensions.width.whole + (productInfo.dimensions.width.decimal || 0) / 10;
    const heightCm = productInfo.dimensions.height.whole + (productInfo.dimensions.height.decimal || 0) / 10;
    const diagonal = Math.sqrt(Math.pow(widthCm, 2) + Math.pow(heightCm, 2));
    const diagonalInches = Math.round(diagonal / 2.54);
    return diagonalInches.toString();
  }
  
  return 'Unknown';
};

const getOdmFromModel = (modelName, companyInfo) => {
  if (!modelName && !companyInfo) return 'Unknown';
  
  // Check companyInfo first
  if (companyInfo && companyInfo !== 'OBM RD') {
    return companyInfo;
  }
  
  // Extract ODM from model name patterns
  if (modelName) {
    if (modelName.includes('LNT')) return 'LNT';
    if (modelName.includes('HFL')) return 'TPV ODM(XM)';
    if (modelName.includes('AOC') || modelName.includes('E4CV')) return 'TPV ODM(FQ)';
  }
  
  return 'TPV ODM(FQ)'; // Default for MNT
};

const getBrandFromModel = (modelName) => {
  if (!modelName) return 'Unknown';
  
  // Extract brand from model name
  if (modelName.includes('HFL')) return 'PHILIPS';
  if (modelName.includes('AOC') || modelName.includes('E4CV')) return 'AOC';
  if (modelName.includes('U27U3XD')) return 'AOC';
  
  // Default brand extraction from first part of model name
  const brandMatch = modelName.match(/^([A-Za-z]+)/);
  if (brandMatch) {
    const brand = brandMatch[1].toUpperCase();
    const knownBrands = ['PHILIPS', 'AOC', 'HP', 'DELL', 'ASUS', 'ACER', 'BENQ', 'MSI', 'SAMSUNG'];
    if (knownBrands.includes(brand)) {
      return brand;
    }
  }
  
  return 'AOC'; // Default for MNT
};

const ProductTypeDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, productTypeRef }) => (
  <div className="mb-3 sm:mb-4 relative" ref={productTypeRef}>
    <div
      className="relative cursor-pointer"
      onClick={() => setOpenDropdown(openDropdown === 'productType' ? null : 'productType')}
    >
      <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2.5 sm:px-4 sm:py-3 text-white text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between hover:border-slate-500 transition-colors">
        <span className="truncate">
          {filters.productType === '' ? 'Product Type' : filters.productType === 'All' ? 'All' : filters.productType}
        </span>
        <div className="flex flex-col items-center ml-2 flex-shrink-0">
          <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
          <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
        </div>
      </div>
    </div>
    {openDropdown === 'productType' && (
      <div className="absolute top-full left-0 right-0 mt-1 bg-slate-800 rounded-lg border border-blue-500 z-50 shadow-xl max-w-full">
        <div className="relative flex items-center px-3 py-2 sm:px-4 sm:py-2.5 border-b border-slate-700">
          <X
            onClick={() => setOpenDropdown(null)}
            className="absolute left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
          />
          <span className="mx-auto text-white text-sm font-medium">Product Type</span>
        </div>
        <div className="p-0 max-h-60 overflow-y-auto">
          {productTypeOptions.map((option) => (
            <div
              key={option.value}
              className="flex items-center justify-between px-3 py-2.5 sm:px-4 sm:py-3 hover:bg-slate-600 cursor-pointer border-b border-slate-700 last:border-b-0 transition-colors"
              onClick={() => handleFilterChange('productType', option.value)}
            >
              <span className="text-white text-sm">{option.label}</span>
              <div className="w-5 h-5 rounded-full border-2 border-slate-500 flex items-center justify-center flex-shrink-0">
                {filters.productType === option.value && <div className="w-2.5 h-2.5 rounded-full bg-white"></div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

const SizeDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, sizeRef, sizeOptions }) => {
  const sizePairs = [];
  for (let i = 0; i < sizeOptions.length; i += 2) {
    sizePairs.push([sizeOptions[i], sizeOptions[i + 1]].filter(Boolean));
  }

  return (
    <div className="mb-3 sm:mb-4 relative" ref={sizeRef}>
      <div
        className="relative cursor-pointer"
        onClick={() => setOpenDropdown(openDropdown === 'size' ? null : 'size')}
      >
        <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2.5 sm:px-4 sm:py-3 text-white text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between hover:border-slate-500 transition-colors">
          <span className="truncate">{filters.size === '' ? 'Size' : filters.size}</span>
          <div className="flex flex-col items-center ml-2 flex-shrink-0">
            <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
            <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
          </div>
        </div>
      </div>
      {openDropdown === 'size' && sizeOptions.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-slate-800 rounded-lg border-2 border-blue-500 z-50 shadow-xl max-w-full">
          <div className="relative flex items-center px-3 py-2 sm:px-4 sm:py-2.5 border-b border-slate-700">
            <X
              onClick={() => setOpenDropdown(null)}
              className="absolute left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
            />
            <span className="mx-auto text-white text-sm font-medium">Size</span>
          </div>
          <div className="p-2 sm:p-4 max-h-80 overflow-y-auto">
            {sizePairs.map((pair, index) => (
              <div key={index} className="grid grid-cols-2 gap-2 mb-2">
                {pair.map((size) => (
                  <div
                    key={size}
                    className="flex items-center justify-between px-3 py-2.5 hover:bg-slate-600 cursor-pointer border border-slate-700 rounded transition-colors"
                    onClick={() => handleFilterChange('size', size)}
                  >
                    <span className="text-white text-sm">{size}</span>
                    <div
                      className={`w-4 h-4 border-2 flex items-center justify-center flex-shrink-0 ${
                        filters.size === size ? 'border-blue-500 bg-blue-500' : 'border-slate-500'
                      }`}
                      style={{ borderRadius: '2px' }}
                    >
                      {filters.size === size && (
                        <div className="w-2 h-2 bg-white" style={{ borderRadius: '1px' }}></div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const OdmDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, odmRef, odmOptions }) => (
  <div className="mb-3 sm:mb-4 relative" ref={odmRef}>
    <div
      className="relative cursor-pointer"
      onClick={() => setOpenDropdown(openDropdown === 'odm' ? null : 'odm')}
    >
      <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2.5 sm:px-4 sm:py-3 text-white text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between hover:border-slate-500 transition-colors">
        <span className="truncate">{filters.odm === '' ? 'ODM' : filters.odm === 'All' ? 'All' : filters.odm}</span>
        <div className="flex flex-col items-center ml-2 flex-shrink-0">
          <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
          <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
        </div>
      </div>
    </div>
    {openDropdown === 'odm' && odmOptions.length > 0 && (
      <div className="absolute top-full left-0 right-0 mt-1 bg-slate-800 rounded-lg border border-blue-500 z-50 shadow-xl max-w-full">
        <div className="relative flex items-center px-3 py-2 sm:px-4 sm:py-2.5 border-b border-slate-700">
          <X
            onClick={() => setOpenDropdown(null)}
            className="absolute left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
          />
          <span className="mx-auto text-white text-sm font-medium">ODM</span>
        </div>
        <div className="p-0 max-h-60 overflow-y-auto">
          {odmOptions.map((option) => (
            <div
              key={option}
              className="flex items-center justify-between px-3 py-2.5 sm:px-4 sm:py-3 hover:bg-slate-600 cursor-pointer border-b border-slate-700 last:border-b-0 transition-colors"
              onClick={() => handleFilterChange('odm', option)}
            >
              <span className="text-white text-sm truncate">{option}</span>
              <div className="w-5 h-5 rounded-full border-2 border-slate-500 flex items-center justify-center flex-shrink-0 ml-2">
                {filters.odm === option && <div className="w-2.5 h-2.5 rounded-full bg-white"></div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

const BrandDropdown = ({ filters, handleFilterChange, openDropdown, setOpenDropdown, brandRef, brandOptions }) => (
  <div className="mb-3 sm:mb-4 relative" ref={brandRef}>
    <div
      className="relative cursor-pointer"
      onClick={() => setOpenDropdown(openDropdown === 'brand' ? null : 'brand')}
    >
      <div className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2.5 sm:px-4 sm:py-3 text-white text-sm focus:outline-none focus:border-blue-500 flex items-center justify-between hover:border-slate-500 transition-colors">
        <span className="truncate">{filters.brand === '' ? 'Brand' : filters.brand}</span>
        <div className="flex flex-col items-center ml-2 flex-shrink-0">
          <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
          <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
        </div>
      </div>
    </div>
    {openDropdown === 'brand' && brandOptions.length > 0 && (
      <div className="absolute top-full left-0 right-0 mt-1 bg-slate-800 rounded-lg border border-blue-500 z-50 shadow-xl max-w-full">
        <div className="relative flex items-center px-3 py-2 sm:px-4 sm:py-2.5 border-b border-slate-700">
          <X
            onClick={() => setOpenDropdown(null)}
            className="absolute left-3 w-4 h-4 sm:w-5 sm:h-5 text-white hover:text-gray-300 cursor-pointer"
          />
          <span className="mx-auto text-white text-sm font-medium">Brand</span>
        </div>
        <div className="p-0 max-h-60 overflow-y-auto">
          {brandOptions.map((option) => (
            <div
              key={option}
              className="flex items-center justify-between px-3 py-2.5 sm:px-4 sm:py-3 hover:bg-slate-600 cursor-pointer border-b border-slate-700 last:border-b-0 transition-colors"
              onClick={() => handleFilterChange('brand', option)}
            >
              <span className="text-white text-sm truncate">{option}</span>
              <div className="w-5 h-5 rounded-full border-2 border-slate-500 flex items-center justify-center flex-shrink-0 ml-2">
                {filters.brand === option && <div className="w-2.5 h-2.5 rounded-full bg-white"></div>}
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

const FilterDropdown = ({ label, value, onChange, name }) => (
  <div className="mb-3 sm:mb-4 relative">
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2.5 sm:px-4 sm:py-3 pr-10 text-white text-sm appearance-none focus:outline-none focus:border-blue-500 hover:border-slate-500 transition-colors cursor-pointer"
      >
        <option value="">{label}</option>
        <option value="All">All</option>
        <option value="last_week">Last Week</option>
        <option value="last_month">Last Month</option>
        <option value="current_month">Current Month</option>
        <option value="last_3_months">Within Three Months</option>
        <option value="last_6_months">Within Six Months</option>
        <option value="within_year">Within One Year</option>
        <option value="custom">Custom</option>
      </select>
      <div className="absolute right-3 top-1/2 -translate-y-1/2 flex flex-col items-center pointer-events-none">
        <ChevronUp className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
        <ChevronDown className="text-slate-400 w-3 h-3 sm:w-4 sm:h-4" />
      </div>
    </div>
  </div>
);

const DefectChart = ({
  chartData,
  currentFilters,
  currentChartData,
  sizeOptions,
  odmOptions,
  brandOptions,
  setSelectedDefectType = () => console.warn('setSelectedDefectType not provided'),
}) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const navigate = useNavigate();

  const handleLabelClick = (defectType) => {
    if (typeof setSelectedDefectType === 'function') {
      setSelectedDefectType(defectType);
      localStorage.setItem('dashboardFilters', JSON.stringify(currentFilters));
      localStorage.setItem('dashboardChartData', JSON.stringify(currentChartData));
      navigate('/photo-gallery', {
        state: {
          defectType: defectType,
          filters: currentFilters,
          chartData: currentChartData,
          sizeOptions: sizeOptions,
          odmOptions: odmOptions,
          brandOptions: brandOptions,
        },
      });
    } else {
      console.error('setSelectedDefectType is not a function');
    }
  };

  useEffect(() => {
    const ctx = chartRef.current?.getContext('2d');
    if (!ctx) return;

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
      chartInstanceRef.current = null;
    }
    
    const filteredChartData = chartData.filter(item => item.label.toLowerCase() !== 'other');

    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.font = '11px sans-serif';

    const labelWidths = filteredChartData.map((item) => Math.max(35, tempCtx.measureText(item.label).width + 15));

    chartInstanceRef.current = new ChartJS(ctx, {
      type: 'bar',
      data: {
        labels: filteredChartData.map((item) => item.label),
        datasets: [
          {
            label: 'Defect Quantity',
            data: filteredChartData.map((item) => item.quantity),
            backgroundColor: 'rgba(71, 85, 105, 0.8)',
            hoverBackgroundColor: 'rgba(100, 116, 139, 0.8)',
            borderRadius: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            title: { display: false },
            ticks: { display: false },
          },
          x: {
            ticks: {
              color: '#e2e8f0',
              maxRotation: 0,
              minRotation: 0,
              autoSkip: false,
              padding: 5,
              font: { size: 10 },
              callback: function (value) {
                const label = this.getLabelForValue(value);
                if (label.toLowerCase().includes("pressing light leakage")) {
                  return label + "               ";
                }
                return label;
              },
            },
            grid: { display: false },
            offset: true,
            afterFit: function (axis) {
              axis.paddingLeft = 5;
              axis.paddingRight = 5;
            },
            categoryPercentage: 0.9,
            barPercentage: 0.9,
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#1e293b',
            titleColor: '#e2e8f0',
            bodyColor: '#e2e8f0',
          },
        },
        layout: {
          padding: { left: 26, top: 10 },
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index;
            const item = filteredChartData[index];
            if (item && item.label) {
              handleLabelClick(item.label);
            } else {
              console.warn('No label found for clicked element');
            }
          }
        },
      },
      plugins: [
        {
          id: 'barEndLine',
          afterDatasetsDraw(chart) {
            const { ctx } = chart;
            const meta = chart.getDatasetMeta(0);

            ctx.save();
            ctx.strokeStyle = 'white';
            ctx.lineWidth = 1;

            meta.data.forEach((bar) => {
              const { x, y, width } = bar;
              const left = x - width / 2;
              const right = x + width / 2;

              ctx.beginPath();
              ctx.moveTo(left, y);
              ctx.lineTo(right, y);
              ctx.stroke();
            });

            ctx.restore();
          },
        },
      ],
    });

    const totalWidth = labelWidths.reduce((sum, width) => sum + width, 0);
    const container = chartRef.current.parentElement;
    container.style.width = `${Math.max(650, totalWidth + 20)}px`;

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
        chartInstanceRef.current = null;
      }
    };
  }, [chartData, currentFilters, currentChartData, sizeOptions, odmOptions, brandOptions, setSelectedDefectType, navigate]);

  return (
    <div className="w-full overflow-x-auto overflow-y-hidden scrollbar-thin scrollbar-thumb-slate-600 scrollbar-track-slate-800">
      <div className="min-w-[650px] h-[250px] sm:h-[280px] lg:h-[320px] p-1 sm:p-2 relative">
        <canvas ref={chartRef} className="w-full h-full block" />
      </div>
    </div>
  );
};

DefectChart.propTypes = {
  chartData: PropTypes.array.isRequired,
  currentFilters: PropTypes.object.isRequired,
  currentChartData: PropTypes.array.isRequired,
  sizeOptions: PropTypes.array.isRequired,
  odmOptions: PropTypes.array.isRequired,
  brandOptions: PropTypes.array.isRequired,
  setSelectedDefectType: PropTypes.func,
};

const StatisticsAndAnalysis = () => {
  const [filters, setFilters] = useState({
    productType: 'All',
    size: 'All',
    odm: 'All',
    brand: 'All',
    datePeriod: 'All',
    customDateFrom: '',
    customDateTo: '',
  });
  const [selectedDefectType, setSelectedDefectType] = useState('');
  const [currentChartData, setCurrentChartData] = useState([]);
  const [chartDataState, setChartDataState] = useState([]);
  const [allData, setAllData] = useState([]);
  const [sizeOptions, setSizeOptions] = useState(['All']);
  const [odmOptions, setOdmOptions] = useState(['All']);
  const [brandOptions, setBrandOptions] = useState(['All']);
  const [analysisData, setAnalysisData] = useState([]);
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
  const productTypeRef = useRef(null);
  const sizeRef = useRef(null);
  const odmRef = useRef(null);
  const brandRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [filtersApplied, setFiltersApplied] = useState(false);

  const isFormValid = () => {
    const basicFieldsValid =
      filters.productType && filters.productType !== '' &&
      filters.size && filters.size !== '' &&
      filters.odm && filters.odm !== '' &&
      filters.brand && filters.brand !== '' &&
      filters.datePeriod && filters.datePeriod !== '';
  
    if (filters.datePeriod === 'custom') {
      return basicFieldsValid && filters.customDateFrom !== '' && filters.customDateTo !== '';
    }
    return basicFieldsValid;
  };
  
  const formatMuraType = (muraType) => {
    if (!muraType) return 'Unknown';
    return muraType
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const processChartData = (data) => {
    const dataArray = Array.isArray(data) ? data : data?.data || [];
    if (!Array.isArray(dataArray)) {
      console.error('processChartData: Expected an array but received:', data);
      return [];
    }

    const muraTypeCounts = {};
    let totalDefects = 0;
    
    dataArray.forEach(item => {
      if (item.status !== "accepted") {
        return;
      }
      let defects = [];
      
      if (item.MuraRecording && item.MuraRecording.muraLabeling && item.MuraRecording.muraLabeling.defects) {
        defects = item.MuraRecording.muraLabeling.defects;
      } else if (item.muraLabeling && item.muraLabeling.defects) {
        defects = item.muraLabeling.defects;
      } else if (item.defects) {
        defects = item.defects;
      }
      
      if (!Array.isArray(defects)) {
        console.warn('Defects is not an array:', defects);
        defects = [];
      }

      defects.forEach(defect => {
        const muraType = defect?.muraType || defect?.type || 'Unknown';
        if (muraType) {
          muraTypeCounts[muraType] = (muraTypeCounts[muraType] || 0) + 1;
          totalDefects += 1;
        }
      });
    });

    const formattedData = Object.entries(muraTypeCounts)
      .map(([muraType, quantity], index) => ({
        id: index + 1,
        label: formatMuraType(muraType),
        quantity,
      }))
      .filter(item => item.label !== "Other")
      .sort((a, b) => b.quantity - a.quantity);
    return formattedData;
  };

  const handleLabelClick = (defectType) => {
    setSelectedDefectType(defectType);
    navigate('/photo-gallery', {
      state: {
        defectType,
        filters: { ...filters },
        analysis: currentChartData,
        sizeOptions,
        odmOptions,
        brandOptions,
      },
    });
  };

  useEffect(() => {
    const { state } = location;
    let initialFilters = {
      productType: 'All',
      size: 'All',
      odm: 'All',
      brand: 'All',
      datePeriod: 'All',
      customDateFrom: '',
      customDateTo: '',
    };
    let initialSizeOptions = ['All'];
    let initialOdmOptions = ['All'];
    let initialBrandOptions = ['All'];

    const normalizeData = (data) => {
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.data)) return data.data;
      if (data && Array.isArray(data.results)) return data.results;
      return [];
    };

    if (state && state.analysis) {
      const analysisArray = normalizeData(state.analysis);
      if (analysisArray.length > 0) {
        setAnalysisData(analysisArray);
        setAllData(analysisArray);
        const formattedData = processChartData(analysisArray);
        setCurrentChartData(analysisArray);
        setChartDataState(formattedData);
        setHasAppliedFilters(false);
      } else {
        console.error('Analysis data is empty or invalid:', state.analysis);
        Swal.fire({
          icon: 'error',
          title: 'Invalid Data',
          text: 'The analysis data received is empty or not in the expected format.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#ff4444',
        });
      }
      if (state && state.filters) {
        initialFilters = { ...state.filters };
      }
    } else {
      const storedFilters = localStorage.getItem('dashboardFilters');
      const storedChartData = localStorage.getItem('dashboardChartData');
      if (storedFilters) {
        try {
          initialFilters = JSON.parse(storedFilters);
        } catch (error) {
          console.error('Error parsing stored filters:', error);
        }
      }
      if (storedChartData) {
        try {
          const parsedData = JSON.parse(storedChartData);
          const analysisArray = normalizeData(parsedData);
          if (analysisArray.length > 0) {
            setAnalysisData(analysisArray);
            setAllData(analysisArray);
            const formattedData = processChartData(analysisArray);
            setCurrentChartData(analysisArray);
            setChartDataState(formattedData);
            setHasAppliedFilters(false);
          } else {
            console.error('Stored chart data is empty or invalid:', parsedData);
          }
        } catch (error) {
          console.error('Error parsing stored chart data:', error);
        }
      }
    }

    const selectedProduct = productTypeData.productTypes.find((pt) => pt.type === initialFilters.productType) || {
      size: ['All'],
      odm: ['All'],
      brand: ['All'],
    };
    initialSizeOptions = state?.sizeOptions || [...selectedProduct.size];
    initialOdmOptions = state?.odmOptions || [...selectedProduct.odm];
    initialBrandOptions = state?.brandOptions || [...selectedProduct.brand];

    setFilters(initialFilters);
    setSizeOptions(initialSizeOptions);
    setOdmOptions(initialOdmOptions);
    setBrandOptions(initialBrandOptions);
  }, [location]);

  useEffect(() => {
    if (filters.productType && filters.productType !== 'Product Type') {
      const selectedProduct = productTypeData.productTypes.find((pt) => pt.type === filters.productType) || {
        size: ['All'],
        odm: ['All'],
        brand: ['All'],
      };
      setSizeOptions([...selectedProduct.size]);
      setOdmOptions([...selectedProduct.odm]);
      setBrandOptions([...selectedProduct.brand]);
    } else {
      setSizeOptions(['All']);
      setOdmOptions(['All']);
      setBrandOptions(['All']);
    }
  }, [filters.productType]);

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    setOpenDropdown(null);
    setFiltersApplied(false); 
    localStorage.setItem('dashboardFilters', JSON.stringify({ ...filters, [name]: value }));
  };

  // Fixed updateChart function with corrected date filtering
  const updateChart = () => {
    if (!Array.isArray(allData) || allData.length === 0) {
      console.error('All data is not an array or is empty:', allData);
      Swal.fire({
        icon: 'error',
        title: 'No Data Available',
        text: 'No valid data available to filter.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
      return;
    }

    try {
      let filteredData = [...allData];
      console.log('Initial data count:', filteredData.length);

      // Product Type Filter
      if (filters.productType && filters.productType !== 'All') {
        filteredData = filteredData.filter(item => {
          const itemProductType = item.productInfo?.productType || '';
          return String(itemProductType).toLowerCase() === String(filters.productType).toLowerCase();
        });
        console.log('After product type filter:', filteredData.length);
      }

      // Size Filter with improved logic
      if (filters.size && filters.size !== 'All') {
        filteredData = filteredData.filter(item => {
          const extractedSize = extractSizeFromProduct(item.productInfo);
          const isMatch = String(extractedSize) === String(filters.size);
          if (!isMatch) {
            console.log('Size mismatch:', extractedSize, 'vs', filters.size, 'for model:', item.productInfo?.modelName);
          }
          return isMatch;
        });
        console.log('After size filter:', filteredData.length);
      }

      // ODM Filter with improved logic
      if (filters.odm && filters.odm !== 'All') {
        filteredData = filteredData.filter(item => {
          const extractedOdm = getOdmFromModel(item.productInfo?.modelName, item.productInfo?.companyInfo);
          const isMatch = String(extractedOdm) === String(filters.odm);
          if (!isMatch) {
            console.log('ODM mismatch:', extractedOdm, 'vs', filters.odm, 'for model:', item.productInfo?.modelName);
          }
          return isMatch;
        });
        console.log('After ODM filter:', filteredData.length);
      }

      if (filters.brand && filters.brand !== 'All') {
        filteredData = filteredData.filter(item => {
          const extractedBrand = getBrandFromModel(item.productInfo?.modelName);
          const isMatch = String(extractedBrand).toLowerCase().includes(String(filters.brand).toLowerCase()) ||
                          String(filters.brand).toLowerCase().includes(String(extractedBrand).toLowerCase());
          if (!isMatch) {
            console.log('Brand mismatch:', extractedBrand, 'vs', filters.brand, 'for model:', item.productInfo?.modelName);
          }
          return isMatch;
        });
        console.log('After brand filter:', filteredData.length);
      }

      if (filters.datePeriod && filters.datePeriod !== 'All') {
        let fromDate, toDate;
        const now = new Date();

        if (filters.datePeriod === 'custom' && filters.customDateFrom && filters.customDateTo) {
          fromDate = new Date(filters.customDateFrom);
          toDate = new Date(filters.customDateTo);
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
        } else if (filters.datePeriod === 'last_week') {
          toDate = new Date(now);
          fromDate = new Date(now);
          fromDate.setDate(toDate.getDate() - 7);
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
        } else if (filters.datePeriod === 'last_month') {
          toDate = new Date(now);
          fromDate = new Date(now);
          fromDate.setMonth(toDate.getMonth() - 1);
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
        } else if (filters.datePeriod === 'current_month') {
          toDate = new Date(now);
          fromDate = new Date(now.getFullYear(), now.getMonth(), 1);
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
        } else if (filters.datePeriod === 'last_3_months') {
          toDate = new Date(now);
          fromDate = new Date(now);
          fromDate.setMonth(toDate.getMonth() - 3);
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
        } else if (filters.datePeriod === 'last_6_months') {
          toDate = new Date(now);
          fromDate = new Date(now);
          fromDate.setMonth(toDate.getMonth() - 6);
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
        } else if (filters.datePeriod === 'within_year') {
          toDate = new Date(now);
          fromDate = new Date(now);
          fromDate.setFullYear(toDate.getFullYear() - 1);
          fromDate.setHours(0, 0, 0, 0);
          toDate.setHours(23, 59, 59, 999);
        }

        if (fromDate && toDate && !isNaN(fromDate) && !isNaN(toDate)) {
          console.log('Date range:', fromDate.toISOString(), 'to', toDate.toISOString());
          
          filteredData = filteredData.filter(item => {
            const itemDateStr = item.createdAt || '';
            if (!itemDateStr) {
              console.log('No createdAt for item:', item._id);
              return false;
            }
            
            const itemDate = new Date(itemDateStr);
            if (isNaN(itemDate.getTime())) {
              console.warn('Invalid date format:', itemDateStr);
              return false;
            }
            
            const isInRange = itemDate >= fromDate && itemDate <= toDate;
            if (!isInRange) {
              console.log('Date out of range:', itemDate.toISOString(), 'not between', fromDate.toISOString(), 'and', toDate.toISOString());
            }
            return isInRange;
          });
          console.log('After date filter:', filteredData.length);
        }
      }

      const formattedData = processChartData(filteredData);
      setCurrentChartData(filteredData);
      setChartDataState(formattedData);
      setHasAppliedFilters(true);
      setFiltersApplied(true);
      
      localStorage.setItem('dashboardChartData', JSON.stringify(filteredData));
      localStorage.setItem('dashboardFilters', JSON.stringify(filters));

      if (filteredData.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'No Data Found',
          text: 'No data matches the selected filters. Try adjusting your filter criteria.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#ff9800',
        });
      }
    } catch (error) {
      console.error('Error filtering chart data:', error);
      Swal.fire({
        icon: 'error',
        title: 'Failed to Filter Data',
        text: error.message || 'Something went wrong filtering the data.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
    }
  };

  // Export function with same filtering logic
const exportData = async () => {
  try {
    let dataToExport;
    if (filtersApplied) {
      dataToExport = currentChartData;
    } else {
      dataToExport = allData;
    }

    if (!Array.isArray(dataToExport) || dataToExport.length === 0) {
      console.error('Data to export is not an array or is empty:', dataToExport);
      Swal.fire({
        icon: 'error',
        title: 'No Data Available',
        text: 'No valid data available to export.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
      return;
    }

    // Extract IDs
    let ids = dataToExport.map(item => item._id).filter(Boolean);

    if (ids.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Valid Records',
        text: 'No valid record IDs found.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff9800',
      });
      return;
    }

    console.log(`Exporting ${ids.length} IDs`);

    const batchSize = 2000;
    const idBatches = [];
    for (let i = 0; i < ids.length; i += batchSize) {
      idBatches.push(ids.slice(i, i + batchSize));
    }

    Swal.fire({
      title: 'Generating Excel File...',
      text: `Processing ${ids.length} records in ${idBatches.length} batches`,
      icon: 'info',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    const results = [];
    for (const batch of idBatches) {
      const result = await downloadMuraExcel({ ids: batch });
      if (result.success && result.downloadUrl) {
        results.push({ downloadUrl: result.downloadUrl, filename: result.filename });
      } else {
        throw new Error(result.message || 'Failed to generate Excel file for batch');
      }
    }

    Swal.close();
    Swal.fire({
      icon: 'success',
      title: 'Excel Generated Successfully!',
      text: `${ids.length} records exported across ${results.length} files. Download will start automatically.`,
      confirmButtonText: 'OK',
      confirmButtonColor: '#4CAF50',
      timer: 5000,
      timerProgressBar: true,
    });

    // Trigger downloads for each file
    results.forEach(result => {
      const downloadLink = `${process.env.REACT_APP_BACKEND_URL}${result.downloadUrl}`;
      window.open(downloadLink, '_blank');
    });

  } catch (error) {
    console.error('Export failed:', error);
    Swal.close();
    
    if (error.message.includes('Authentication error') || error.message.includes('401') || error.message.includes('token')) {
      Swal.fire({
        icon: 'error',
        title: 'Authentication Failed',
        text: 'Your session has expired. Please log in again.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
    } else if (error.message.includes('403')) {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'You do not have permission to export data.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
    } else if (error.message.includes('400') || error.message.includes('Invalid data')) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Data',
        text: 'The data format is invalid. Please try again.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
    } else if (error.message.includes('500') || error.message.includes('Server error')) {
      Swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: 'Server is temporarily unavailable. Please try again later.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'An error occurred while exporting data.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff4444',
      });
    }
  }
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        productTypeRef.current &&
        !productTypeRef.current.contains(event.target) &&
        sizeRef.current &&
        !sizeRef.current.contains(event.target) &&
        odmRef.current &&
        !odmRef.current.contains(event.target) &&
        brandRef.current &&
        !brandRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <div className="bg-black text-white px-4 sm:px-6 py-3 sm:py-4 flex items-center border-b border-gray-600 sticky top-0 z-40">
        <ArrowLeft
          className="w-5 h-5 sm:w-6 sm:h-6 mr-3 text-white cursor-pointer hover:text-gray-300 transition-colors flex-shrink-0"
          onClick={handleBackClick}
        />
        <h1 className="text-base sm:text-lg md:text-xl font-medium truncate">Statistics and Analysis</h1>
      </div>

      <div className="flex flex-col lg:flex-row min-h-[calc(100vh-60px)]">
        {/* Filter Sidebar - Responsive */}
        <div className="w-full lg:w-80 xl:w-96 bg-black p-4 sm:p-5 lg:p-6 border-b lg:border-b-0 lg:border-r border-gray-700 lg:sticky lg:top-[60px] lg:h-[calc(100vh-60px)] lg:overflow-y-auto">
          <h2 className="text-lg sm:text-xl font-medium mb-4 sm:mb-5 lg:mb-6">Filter Dimensions</h2>
          
          <ProductTypeDropdown
            filters={filters}
            handleFilterChange={handleFilterChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            productTypeRef={productTypeRef}
          />
          
          <SizeDropdown
            filters={filters}
            handleFilterChange={handleFilterChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            sizeRef={sizeRef}
            sizeOptions={sizeOptions}
          />
          
          <OdmDropdown
            filters={filters}
            handleFilterChange={handleFilterChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            odmRef={odmRef}
            odmOptions={odmOptions}
          />
          
          <BrandDropdown
            filters={filters}
            handleFilterChange={handleFilterChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            brandRef={brandRef}
            brandOptions={brandOptions}
          />
          
          <FilterDropdown
            label="Date Period"
            value={filters.datePeriod}
            onChange={handleFilterChange}
            name="datePeriod"
          />
          
          {filters.datePeriod === 'custom' && (
            <div className="mb-4">
              <h3 className="text-sm font-medium mb-2 text-slate-300">Custom Date Range</h3>
              <div className="space-y-3">
                <DatePicker
                  selected={filters.customDateFrom ? new Date(filters.customDateFrom) : null}
                  onChange={date =>
                    handleFilterChange(
                      'customDateFrom',
                      date ? date.toLocaleDateString('en-CA') : ''
                    )
                  }
                  placeholderText="From"
                  className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2.5 sm:px-4 sm:py-3 text-white text-sm placeholder-slate-400 focus:outline-none focus:border-blue-500"
                  dateFormat="yyyy-MM-dd"
                  maxDate={filters.customDateTo ? new Date(filters.customDateTo) : null}
                />
                <DatePicker
                  selected={filters.customDateTo ? new Date(filters.customDateTo) : null}
                  onChange={date =>
                    handleFilterChange(
                      'customDateTo',
                      date ? date.toLocaleDateString('en-CA') : ''
                    )
                  }
                  placeholderText="To"
                  className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2.5 sm:px-4 sm:py-3 text-white text-sm placeholder-slate-400 focus:outline-none focus:border-blue-500"
                  dateFormat="yyyy-MM-dd"
                  minDate={filters.customDateFrom ? new Date(filters.customDateFrom) : null}
                />
              </div>
            </div>
          )}

          <button
            onClick={updateChart}
            disabled={!isFormValid()}
            className={`w-full py-2.5 sm:py-3 px-4 rounded-full mb-3 text-sm font-medium transition-all duration-200 ${
              isFormValid() 
                ? "bg-blue-600 hover:bg-blue-500 text-white cursor-pointer shadow-lg hover:shadow-xl" 
                : "bg-slate-700 text-slate-400 cursor-not-allowed"
            }`}
          >
            {filtersApplied ? "Chart Updated ✓" : "Update Chart"}
          </button>
          
          <button
            onClick={exportData}
            className="w-full bg-slate-800 hover:bg-slate-700 text-white py-2.5 sm:py-3 px-4 rounded-full text-sm font-medium transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Export Data
          </button>
        </div>
        
        {/* Main Content Area - Responsive */}
        <div className="flex-1 bg-black p-4 sm:p-5 lg:p-6 overflow-x-hidden">
          {/* Chart Section Header */}
          <div className="mb-4 sm:mb-6">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-medium mb-2">Defect Data Overview</h1>
            <p className="text-slate-400 text-sm">
              Interactive visualization of product defect statistics
            </p>
          </div>

          {/* Chart Container - Responsive with Scroll */}
          <div className="bg-slate-900 rounded-lg p-4 sm:p-5 mb-4 sm:mb-6 border border-gray-700 shadow-xl">
            <div className="mb-3 sm:mb-4">
              <h2 className="text-base sm:text-lg font-medium">Defect Distribution by Issue Type</h2>
            </div>
            <div className="relative bg-black rounded-lg overflow-hidden">
              {chartDataState.length > 0 || !hasAppliedFilters ? (
                <DefectChart
                  chartData={chartDataState}
                  currentFilters={filters}
                  currentChartData={currentChartData}
                  sizeOptions={sizeOptions}
                  odmOptions={odmOptions}
                  brandOptions={brandOptions}
                  setSelectedDefectType={setSelectedDefectType}
                  onLabelClick={handleLabelClick}
                />
              ) : (
                <div className="text-slate-400 text-center py-8 sm:py-12 text-sm sm:text-base">
                  No defect data available for the selected filters
                </div>
              )}
            </div>
          </div>
          
          {/* Chart Detail Table - Responsive */}
          <div className="bg-slate-900 rounded-lg p-4 sm:p-5 border border-gray-700 shadow-xl">
            <h3 className="text-lg sm:text-xl font-medium mb-3 sm:mb-4">Chart Detail Info</h3>
            <div className="overflow-x-auto -mx-4 sm:mx-0">
              <div className="inline-block min-w-full align-middle">
                <div className="overflow-hidden">
                  <div className="grid grid-cols-2 text-sm min-w-[400px]">
                    <div className="font-medium bg-gray-800 text-slate-300 py-3 px-4 border-b border-slate-700">
                      Issue Type
                    </div>
                    <div className="font-medium bg-gray-800 text-slate-300 py-3 px-4 border-b border-slate-700">
                      Quantity
                    </div>
                    {chartDataState.length > 0 || !hasAppliedFilters ? (
                      chartDataState.map((item) => (
                        <React.Fragment key={item.id}>
                          <div className="py-3 px-4 border-b border-slate-700 text-slate-200">
                            {item.label}
                          </div>
                          <div className="py-3 px-4 border-b border-slate-700 text-slate-200 font-medium">
                            {item.quantity}
                          </div>
                        </React.Fragment>
                      ))
                    ) : (
                      <div className="col-span-2 py-4 px-4 text-slate-400 text-center">
                        No defect data available for the selected filters
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsAndAnalysis;
